import * as Sentry from '@sentry/angular';
import type { SentryAdapter } from '@mb/common';

/**
 * Angular/Browser-side Sentry Adapter
 * Uses @sentry/angular
 */
export const createAngularSentryAdapter = (): SentryAdapter => {
    return {
        logger: {
            trace: (message: string, attributes: Record<string, unknown>) => {
                Sentry.logger.trace(message, attributes);
            },
            debug: (message: string, attributes: Record<string, unknown>) => {
                Sentry.logger.debug(message, attributes);
            },
            info: (message: string, attributes: Record<string, unknown>) => {
                Sentry.logger.info(message, attributes);
            },
            warn: (message: string, attributes: Record<string, unknown>) => {
                Sentry.logger.warn(message, attributes);
            },
            error: (message: string, attributes: Record<string, unknown>) => {
                Sentry.logger.error(message, attributes);
            },
            fatal: (message: string, attributes: Record<string, unknown>) => {
                Sentry.logger.fatal(message, attributes);
            },
        },
        captureException: (error: Error, context?: {
            level?: 'fatal' | 'error' | 'warning' | 'info' | 'debug';
            tags?: Record<string, string | undefined>;
            extra?: Record<string, unknown>;
        }) => {
            Sentry.captureException(error, context);
        },
    };
};

/**
 * Default client-side Sentry adapter instance
 */
export const sentryAdapter = createAngularSentryAdapter();

